/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Motivationtext1Inputs */

const en__field_motivationtext1 = /** @type {(inputs: _Field_Motivationtext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do you want to participate in the German course? What do you hope to gain? (100–200 words)`)
};

const de__field_motivationtext1 = /** @type {(inputs: _Field_Motivationtext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum möchtest du an dem Deutschkurs teilnehmen? Was erhoffst du dir davon? (100–200 Wörter)`)
};

/**
* | output |
* | --- |
* | "Why do you want to participate in the German course? What do you hope to gain? (100–200 words)" |
*
* @param {_Field_Motivationtext1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_motivationtext1 = /** @type {((inputs?: _Field_Motivationtext1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Motivationtext1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_motivationtext1(inputs)
	return de__field_motivationtext1(inputs)
});
export { _field_motivationtext1 as "_field_motivationText" }